import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "p-m-5" }
const _hoisted_2 = { class: "p-m-0" }
const _hoisted_3 = {
  key: 0,
  class: "p-m-0"
}
const _hoisted_4 = {
  key: 1,
  class: "p-m-0"
}
const _hoisted_5 = {
  key: 2,
  class: "p-m-0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Sidebar = _resolveComponent("Sidebar")
  const _component_Menu = _resolveComponent("Menu")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Sidebar, {
      class: "mySidebar",
      visible: _ctx.sidebarVisible,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (_ctx.sidebarVisible = $event)),
      showCloseIcon: false,
      position: "right",
      onHide: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
    }, {
      default: _withCtx(() => [
        _createVNode("div", {
          id: "sidebarItemsContainer",
          style: _ctx.descriptor.style.sidebarContainer
        }, [
          _createVNode("div", {
            class: "kn-toolbar kn-toolbar--default",
            style: _ctx.descriptor.style.sidebarToolbar
          }, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.documentButtons, (button, index) => {
              return (_openBlock(), _createBlock("span", { key: index }, [
                (button.visible)
                  ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      icon: button.icon,
                      class: button.class,
                      onClick: button.command
                    }, null, 8, ["icon", "class", "onClick"])), [
                      [
                        _directive_tooltip,
                        button.tooltip,
                        void 0,
                        { top: true }
                      ]
                    ])
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ], 4),
          (_ctx.viewType && _ctx.document.previewFile && !_ctx.descriptor.typesWithoutImages.includes(_ctx.viewType))
            ? (_openBlock(), _createBlock("img", {
                key: 0,
                class: "p-mt-5",
                style: _ctx.descriptor.style.sidebarImage,
                align: "center",
                src: _ctx.documentImageSource
              }, null, 12, ["src"]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_1, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.documentFields, (field, index) => {
              return (_openBlock(), _createBlock("div", {
                class: "p-mb-5",
                key: index
              }, [
                _createVNode("h3", _hoisted_2, [
                  _createVNode("b", null, _toDisplayString(_ctx.$t(field.translation)), 1)
                ]),
                (field.type === 'category' && _ctx.datasetCategory)
                  ? (_openBlock(), _createBlock("p", _hoisted_3, _toDisplayString(_ctx.datasetCategory), 1))
                  : _createCommentVNode("", true),
                (field.type === 'date')
                  ? (_openBlock(), _createBlock("p", _hoisted_4, _toDisplayString(_ctx.getFormattedDate(_ctx.document[field.value], {
                                year: 'numeric',
                                month: '2-digit',
                                day: '2-digit',
                                hour: '2-digit',
                                minute: '2-digit',
                                second: '2-digit'
                            })), 1))
                  : _createCommentVNode("", true),
                (field.type != 'date' && field.type != 'category')
                  ? (_openBlock(), _createBlock("p", _hoisted_5, _toDisplayString(_ctx.document[field.value]), 1))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ], 4)
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Menu, {
      id: "optionsMenu",
      ref: "optionsMenu",
      model: _ctx.menuButtons,
      style: _ctx.descriptor.style.menuItems
    }, null, 8, ["model", "style"])
  ], 64))
}